/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TeamSizeResource = {
    Individual: 'INDIVIDUAL',
    Between2And10: 'BETWEEN_2_AND_10',
    Between11And49: 'BETWEEN_11_AND_49',
    Between50And249: 'BETWEEN_50_AND_249',
    Between250And999: 'BETWEEN_250_AND_999',
    Between1000And4999: 'BETWEEN_1000_AND_4999',
    MoreThan5000: 'MORE_THAN_5000',
    LessThan10: 'LESS_THAN_10',
    Between10And49: 'BETWEEN_10_AND_49',
    Between50And199: 'BETWEEN_50_AND_199',
    Between200And499: 'BETWEEN_200_AND_499',
    Between500And1999: 'BETWEEN_500_AND_1999',
    MoreThan2000: 'MORE_THAN_2000'
} as const;
export type TeamSizeResource = typeof TeamSizeResource[keyof typeof TeamSizeResource];


export function instanceOfTeamSizeResource(value: any): boolean {
    for (const key in TeamSizeResource) {
        if (Object.prototype.hasOwnProperty.call(TeamSizeResource, key)) {
            // @ts-ignore
            if (TeamSizeResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TeamSizeResourceFromJSON(json: any): TeamSizeResource {
    return TeamSizeResourceFromJSONTyped(json, false);
}

export function TeamSizeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamSizeResource {
    return json as TeamSizeResource;
}

export function TeamSizeResourceToJSON(value?: TeamSizeResource | null): any {
    return value as any;
}

